import { FieldArray } from '../../../../Common/forms'
import SpecList from './SpecList'
import withAttributeTransient from '../../../Common/HOC/withAttributeTransient'
import { getSpecAttributeFieldByLevel } from '../../../Common/ProposalForm/Shared/util'

const SpecListArrayField = props => {
  const {
    transientField,
    transientModel
  } = props

  const { hasSpecLevel } = transientModel
  const fieldName = `${transientField}.${getSpecAttributeFieldByLevel(hasSpecLevel)}`

  return (
    <FieldArray
      {...props}
      name={fieldName}
      component={SpecList}
    />
  )
}

export default withAttributeTransient(SpecListArrayField)
